import { useCallback } from 'react';

import { useIntl, defineMessages } from 'react-intl';

import { openModal } from 'flavours/glitch/actions/modal';
import { useAppSelector, useAppDispatch } from 'flavours/glitch/store';

const messages = defineMessages({
  preview: { id: 'compose.content-type.preview', defaultMessage: 'Preview' },
});

export const PreviewButton = () => {
  const intl = useIntl();
  const contentType = useAppSelector((state) => state.getIn(['compose', 'content_type']));
  const text = useAppSelector((state) => state.getIn(['compose', 'text']));
  const dispatch = useAppDispatch();

  const handlePreview = useCallback(() => {
    dispatch(openModal({
      modalType: 'PREVIEW',
      modalProps: { text, contentType },
    }));
  }, [dispatch, text, contentType]);

  const showPreview = (contentType === 'text/markdown' || contentType === 'text/html');

  if (!showPreview) {
    return null;
  }

  return (
    <div>
      <button
        type='button'
        title={intl.formatMessage(messages.preview)}
        className='dropdown-button'
        onClick={handlePreview}
      >
        <span className='dropdown-button__label'>
          {intl.formatMessage(messages.preview)}
        </span>
      </button>
    </div>
  );
};
